<script context='module'>

  /**
   * @author M.G.
   */

  import ScheduledEmailPicker from './ScheduledEmailPicker.svelte';
  import { External } from '../../external';
  import { M } from '../../external';
  import { sendTestEmail } from './EmailBuilder.svelte';

  let emailPicker;

  export async function showScheduledEmailList(contact, onSelect, onEmpty, onNoData) {

    if (!contact.subscribed) {
      External.Tools.showError(M.CONTACT_NOT_SUBSCRIBED);
      return;
    }

    let emails = await getScheduledEmails(contact.id, () => {  //fetch the data before opening the popup to avoid the lag between opening the popup and fetching/rendering the list
      onNoData();
    });

    if (emails) {
      External.Tools.showWindow({
        withDarkBackground: true,
        showCloseButton: false,
        noNav: true,
        noTitle: true,
        width: 500,
        action: {
          onShow: (popup, context) => {
            emailPicker = new ScheduledEmailPicker({
              target: popup.getContentArea(),
              props: {
                contact: contact,
                emails: emails,
                popup: popup,
                onSelect: (email) => {
                  if (onSelect(email)) {
                    popup.close();
                  }
                },
                onEmpty: onEmpty
              }
            });
          }
        }
      });
    }
  }

  export function getScheduledEmailContent(contactId, emailId) {
    return new Promise((resolve) => {
      External.Tools.makeWebsiteRequest({
        action: 'getScheduledEmail',
        data: {
          contactId: contactId,
          emailId: emailId
        },

        onOk: (resp) => {
          if (resp.data && resp.data.content) {
            resolve(resp.data.content);
          } else {
            External.Tools.showError(M.NO_EMAIL_DATA_FOUND);
          }
        }
      });
    });
  }

</script>

<script>

  export let contact, emails, popup, onSelect, onEmpty;
  let moreBtns = [];

  function getScheduledEmails(contactId, onNoData) {   //require the contactId because we call this function before the component is mounted, a bit dirty...
    return new Promise((resolve) => {
      External.Tools.makeWebsiteRequest({
        action: 'getScheduledEmails',
        data: {
          contactId: contactId
        },

        onOk: (resp) => {
          if ((!resp.data) || !resp.data.length) {
            onNoData();
          } else {

            let dateFormat = External.WebsiteSettings.getDateFormat();
            let use24HrFormat = dateFormat === 'uk';

            resp.data.forEach((email) => {
              email.execDate = new Date(email.execDate);
              email.execDate.formattedDate = External.Tools.dateToStr(email.execDate, dateFormat) + ' ' + External.Tools.timeToString(email.execDate, use24HrFormat);
            });

            resolve(resp.data);
          }
        }
      });
    });
  }

  async function sendTest(email) {
    email.content = await getScheduledEmailContent(email.contactId, email.emailId);
    sendTestEmail(email);
  }

  function previewScheduledEmail(email) {
    External.Tools.showWebsitePreviewPopup({
      url: 'https://' + External.userDomain + '/me/email?action=previewIndividualEmail&preview=1&scheduled=1&contactId=' + email.contactId + '&emailId=' + email.emailId,
      buttonText: M.SHOW_IN_NEW_TAB,
      onButtonAction: (pageUrl) => {
        window.open(pageUrl, '_blank').focus();
      },
			customClass: 'individual-email-preview'
    });
  }

  function deleteScheduledEmail(email) {
    External.Tools.prompt(M.DELETE_EMAIL, M.DELETE_EMAIL_DESC, () => {
      External.Tools.makeWebsiteRequest({
        action: 'deleteScheduledEmail',
        data: {
          contactId: email.contactId,
          emailId: email.emailId
        },
        onOk: async (resp) => {
          emails = await getScheduledEmails(contact.id, () => {
            popup.close();
            if (onEmpty) {
              onEmpty();
            }
          });
        }
      });
    });
  }

  const MORE_OPTIONS = [
    { text: M.SEND_TEST_EMAIL, icon: 'fa-at', tag: 'test' },
    { text: M.PREVIEW, icon: 'fa-eye', tag: 'preview' },
    { text: M.DELETE, icon: 'fa-trash', tag: 'delete' }
  ];

  function showMoreOptions(moreButton, email) {
    let target = External.$(moreButton);

    External.Tools.showTooltipOptions(target, MORE_OPTIONS, async (target, idx, text, tag) => {
      if (tag === 'delete') {
        deleteScheduledEmail(email);
      } else if (tag === 'preview') {
        previewScheduledEmail(email);
      } else if (tag === 'test') {
        await sendTest(email);
      }
    });
  }

  async function refreshList() {
    emails = await getScheduledEmails(contact.id, () => {
      popup.close();
    });
  }

</script>

<div class='switch-popup-wrapper full-size flex flex-col cpanel-prompt-dialog' style='height: 70vh;'>
  <div class='cpanel-popup-title ui-draggable-handle' style='padding: 0px'>
    <a class='close-btn close-popup'><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg></a>
    <h2 class='col20 ta-center flex-none ui-draggable-handle'>{M.SCHEDULED_EMAILS}</h2>
  </div>
  <div class='switch-popup-content-wrapper col20 flex-1 flex flex-col' style='padding: 0px;'>
    <div class='col20 f-left' style='box-sizing: border-box; padding: 0px 40px;'>
      {#key emails} <!-- renders smoother by re-rendering the entire container -->
        <div class='col20 f-left mt-15'>
          {#each emails as email, i}
            <div class='col20 f-left funnel-inner-wrapper funnel-item-view' on:click={() => onSelect(email)}>
              <div class='col20 f-left funnels-wrapper vertical-flex'>
                <div class='funnel-list-stats blue'>
                  <svg height="48" viewBox="0 -960 960 960" width="48" xmlns="http://www.w3.org/2000/svg"><path d="M140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm340-302L140-685v465h680v-465L480-462Zm0-60 336-218H145l335 218ZM140-685v-55 520-465Z"></path></svg>
                </div>
                <div class='funnel-inner-texts'>
                  <h4 class='col20 f-left ellipsis' style='width: 88%;'>{email.subject}</h4>
                  <span class='col20 f-left mt-10'>
                        <i class='fa fa-circle-arrow-right mr-5' />{email.execDate.formattedDate}
                      </span>
                </div>
                <div class='funnel-controls' style='display: inline'>
                  <a target='_blank' class='more-options button-tooltip' data-tooltip='{M.MORE_OPTIONS}'
                     bind:this={moreBtns[i]} on:click|stopPropagation={() => showMoreOptions(moreBtns[i], email)} />
                </div>
              </div>
            </div>
          {/each}
        </div>
      {/key}
    </div>
  </div>
</div>
